import { render, staticRenderFns } from "./SearchCompanies.vue?vue&type=template&id=6ba68e8b&scoped=true&"
import script from "./SearchCompanies.vue?vue&type=script&lang=js&"
export * from "./SearchCompanies.vue?vue&type=script&lang=js&"
import style0 from "./SearchCompanies.vue?vue&type=style&index=0&id=6ba68e8b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba68e8b",
  null
  
)

export default component.exports